import React from 'react'
import Code from '../assests/Code.png'
function Hero() {
  return (
    <div className='100vh 100vw rotated-gradient py-4 Hero'>
      <div className='flex'>
        <div className='py-11 mx-auto text-center ellipse  '>
          <h1 className='text-white font-normal text-3xl ml-12'>Services we provide</h1>
        </div>
      </div>

      <div className='flex justify-center w-full  py-10 px-8'>
        <div className='w-[1250px] flex flex-col-reverse  md:flex-row m-auto justify-around '>
          <div className=' items-center md:items-start justify-center flex flex-col md:justify-around'>

            <h1 className=' font-semibold text-3xl md:text-5xl text-white pb-7 md:pb-0'>Web Designing</h1>
            <div className=''>
              <ul className='list-disc text-white'>
                <li >
                  <p className='text-xl'><span className=' font-semibold'>Immersive Experiences : </span>
                    <span className='text-[#808080]'> Crafting websites that engage and captivate visitors.</span></p>
                </li>

                <li>
                  <p className=' text-xl'><span className=' font-semibold'>User-Centric Interfaces : </span>
                    <span className='text-[#808080]'> Intuitive designs for seamless navigation.</span></p>
                </li>

                <li>
                  <p className='text-xl'><span className=' font-semibold'>Conversion-Focused : </span>
                    <span className='text-[#808080]'>  Designs optimized to drive tangible business outcomes.</span></p>
                </li>

              </ul>
            </div>
            <button className="mt-5  py-2 md:py-3 px-8 bg-black text-white">
              Contact Us
            </button>
          </div>
          <div className='py-7 m-auto'>
            <img className='p-4' src={Code} alt="" />
          </div>
        </div>
      </div>

    </div>
  )
}

export default Hero